import {isString} from 'ramda-adjunct';

import {getRowCellValue, type RowData} from 'features/eag-grid';

/**
 * Reads a cell's `.value` from a RowData entry and narrows it to a string.
 * Returns undefined for missing columns and non-string values.
 */
export const getStringCellValue = (row: RowData, columnKey: string) => {
  const value = getRowCellValue(row, columnKey);
  return isString(value) ? value : undefined;
};
